import { FormContainer } from '@openx/components-core/lib/FormContainer/FormContainer.tsx';
import { Loader } from '@openx/components-core/lib/Loader/Loader.tsx';
import { PageHeader } from '@openx/components-header/PageHeader.tsx';
import { useTranslation } from 'react-i18next';
import { AudienceFormFields } from './AudienceForm/AudienceFormFields.tsx';
import { useCreateAudience } from './hooks/useCreateAudience.ts';

export const CreateAudiencePage = () => {
  const { t } = useTranslation();
  const { isLoading, createAndActivateAudience, values } = useCreateAudience();

  if (isLoading) {
    return <Loader />;
  }

  return (
    <PageHeader title={t('Create New Audience')} titlePrefix="OpenXSelect">
      <FormContainer fullPage>
        <AudienceFormFields isCreate={true} formValues={values} onSubmitHandler={createAndActivateAudience} />
      </FormContainer>
    </PageHeader>
  );
};
